import { useState, useEffect } from 'react';
import './HeaderClock.css';

/* ═══════════════════════════════════════════════════════════════════════════
   HeaderClock — Live local time display for ShowcaseHeader right slot.
   Ticks every second, respects the event timezone.
   ═══════════════════════════════════════════════════════════════════════════ */

interface HeaderClockProps {
  timezone: string | null;
}

export default function HeaderClock({ timezone }: HeaderClockProps) {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const tz = timezone ?? undefined;
  let dateStr: string;
  let timeStr: string;

  try {
    dateStr = now
      .toLocaleDateString('en-US', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        timeZone: tz,
      })
      .replace(/,/g, '');
    timeStr = now.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: tz,
    });
  } catch {
    dateStr = now
      .toLocaleDateString('en-US', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
      .replace(/,/g, '');
    timeStr = now.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  }

  return (
    <div className="hdr-clock">
      <span className="hdr-clock__date">{dateStr}</span>
      <span className="hdr-clock__time">{timeStr}</span>
    </div>
  );
}
